import { apiSlice, createPaginatedListEndpoint, createBodyMutation } from './baseApi';

export const investmentCategoryApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getInvestmentCategories: builder.query({
      query: (companyId) => ({
        url: '/investment-category/get-all-investment-categories',
        method: 'POST',
        body: { company_id: companyId },
      }),
      transformResponse: (response) => {
        const categories = response?.investmentCategories || [];
        return categories.map((category) => ({
          name: category.name,
          value: category._id,
          ...category,
        }));
      },
      providesTags: ['InvestmentCategories'],
    }),
    getInvestmentCategoriesList: builder.query(
      createPaginatedListEndpoint({
        url: '/investment-category/get-all-investment-categories',
        responseKey: 'investmentCategories',
        tag: 'InvestmentCategories',
      })
    ),
    addInvestmentCategory: builder.mutation(
      createBodyMutation({ url: '/investment-category/add-new-investment-category', invalidatesTags: ['InvestmentCategories'] })
    ),
    editInvestmentCategory: builder.mutation(
      createBodyMutation({ url: '/investment-category/edit-investment-category', invalidatesTags: ['InvestmentCategories'] })
    ),
    deleteInvestmentCategory: builder.mutation(
      createBodyMutation({ url: '/investment-category/delete-investment-category', invalidatesTags: ['InvestmentCategories'] })
    ),
  }),
});
